<template>
  <div
    :class="[fixed ? 'fixed' : 'absolute', 'pointer-events-none inset-0 -z-10 overflow-hidden bg-background']"
    aria-hidden="true"
    data-test="app-background"
  >
    <!-- Tre macchie di colore morbide (gradienti, non filtri di sfocatura: più leggere da disegnare) -->
    <div
      class="absolute -top-[14vmax] -right-[12vmax] size-[46vmax] rounded-full bg-[radial-gradient(closest-side,var(--color-orb-1)_30%,transparent)]"
      data-test="orb"
    />
    <div
      class="absolute -bottom-[24vmax] -left-[20vmax] size-[52vmax] rounded-full bg-[radial-gradient(closest-side,var(--color-orb-2)_30%,transparent)]"
      data-test="orb"
    />
    <div
      class="absolute top-[20%] left-[30%] size-[26vmax] rounded-full bg-[radial-gradient(closest-side,var(--color-orb-3)_30%,transparent)]"
      data-test="orb"
    />

    <!-- File di tracker in prospettiva sul fondo, sfumate verso l'alto -->
    <svg
      class="absolute inset-x-0 bottom-0 h-[42vh] w-full [mask-image:linear-gradient(to_top,#000_55%,transparent)]"
      :viewBox="`0 0 ${LARGHEZZA_CAMPO} ${ALTEZZA_CAMPO}`"
      preserveAspectRatio="xMidYMax slice"
      data-test="file-tracker"
    >
      <g
        v-for="(t, i) in tracker"
        :key="i"
        :transform="`translate(${t.x} ${t.y}) scale(${t.scala})`"
        :opacity="t.opacita"
      >
        <!-- palo, tubo di torsione e pannello a tre moduli con riflesso sul bordo alto -->
        <rect x="-1.6" y="0" width="3.2" height="44" class="fill-campo-palo" />
        <g :transform="`rotate(${t.angolo})`">
          <rect x="-31" y="-4" width="20" height="8" rx="1.6" class="fill-campo-pannello" />
          <rect x="-10" y="-4" width="20" height="8" rx="1.6" class="fill-campo-pannello" />
          <rect x="11" y="-4" width="20" height="8" rx="1.6" class="fill-campo-pannello" />
          <rect x="-31" y="-4" width="62" height="1.6" rx="0.8" class="fill-campo-riflesso" opacity="0.7" />
          <circle r="2.4" class="fill-campo-palo" />
        </g>
      </g>
    </svg>
  </div>
</template>

<script setup lang="ts">
// Sfondo dell'app dal mockup (macchie di colore morbide e file di tracker sul fondo), per tema chiaro e scuro: i colori
// vengono dai token (orb-1/2/3, campo-*). Statico: non si anima e non intercetta il mouse. `fixed` (predefinito) copre la
// finestra, `fixed: false` solo il genitore, che deve essere `relative`. Per ora si usa nel catalogo: nelle pagine entrerà
// quando l'effetto è approvato.
import { ALTEZZA_CAMPO, LARGHEZZA_CAMPO, generaFileTracker } from "~/utils/campoTracker";

withDefaults(defineProps<{ fixed?: boolean }>(), { fixed: true });

const tracker = generaFileTracker();
</script>
